<!-- 
<ion-content class="ion-padding">

  <div *ngIf="!userLoggedIn">
    <video id="video" preload="auto" autoplay muted loop playsinline class="bg-vid">
      <source src="assets/video/veggly.mov" type="video/webm">
      <source src="assets/video/veggly.mov" type="video/mp4">
    </video>
  </div>


  <div class="imgDiv">
    <img src="assets/imgs/logovegglyterms.svg" alt="Veggly Logo">
  </div>

  <div class="welcome">
    {{ 'welcomeToVeggly' | translate }}
  </div>
  <div class="findPeople">
    <p>{{ 'findPeople' | translate }}</p><br>
  </div>

  <div class="featureButtons">
    <ion-button (click)="appleSignin()"  shape="round" class="appleSignin" expand="full" *ngIf="isIos && isNative" [disabled]="processingAppleSignin">
      <div class="featureIcons">
        <ion-icon name="logo-apple" slot="start"></ion-icon>
      </div>
      <div class="featureText">
        {{ 'signInWithApple' | translate }}
      </div>
    </ion-button>

    <ion-button (click)="loginWithFB()"  shape="round" expand="full" [disabled]="processingFacebookSignin">
      <div class="featureIcons">
        <ion-icon name="logo-facebook"></ion-icon>
      </div>
      <div class="featureText">
        {{ 'loginWithFB' | translate }}
      </div>

    </ion-button>

    <ion-button (click)="googleSignIn()" shape="round" expand="full" [disabled]="processingGoogleSignin">
      <div class="featureIcons">
        <ion-icon name="logo-google"></ion-icon>
      </div>
      <div class="featureText">
        {{ 'signInWithGoogle' | translate }}
      </div>
    </ion-button>

    <ion-button (click)="openDefaultLogin()" shape="round" expand="full">
      <div class="featureIcons"> 
        <ion-icon name="mail-sharp"></ion-icon>
      </div>
      <div class="featureText">
        {{ 'loginWithEmail' | translate }}
      </div>
    </ion-button>

  </div>

</ion-content> -->

<ion-content>
  <ng-container *ngIf="isNative || showNativeWebLogin; else webLanding">
  <ion-icon
    *ngIf="showNativeWebLogin"
    name="chevron-back-outline"
    class="web-landing__back native-web-login-back"
    role="button"
    tabindex="0"
    [attr.aria-label]="'webLandingBack' | translate"
    (click)="hideExistingLogin()"
    (keydown.enter)="hideExistingLogin()"
    (keydown.space)="hideExistingLogin()">
  </ion-icon>
  <div *ngIf="!userLoggedIn">
    <video *ngIf="isNative" id="video" preload="auto" autoplay muted loop playsinline class="bg-vid" aria-label="Vídeo de fundo do Veggly">
      <source src="assets/video/veggly.mov" type="video/webm">
      <source src="assets/video/veggly.mov" type="video/mp4">
    </video>
    <img class="logo-veggly" *ngIf="!isNative" src="assets/imgs/logo_novo.svg" alt="Veggly" />
  </div>
  <div class="transparent-box">
    <div class="semi-transparent-box">
      <div class="white-box">
        <div class="welcome-text">{{ 'welcomeToVeggly2' | translate }}</div>
        <div class="description">{{ 'findPeople' | translate }}</div>
        <div class="featureButtons">
          <div class="circleButtonWrapper">
            <ion-button (click)="googleSignIn()" [disabled]="processingGoogleSignin">
              <div class="featureIcons">
                <img src="assets/imgs/icons/google-icon.svg" alt="Google logo" />
              </div>
            </ion-button>
          </div>
          <div class="circleButtonWrapper">
            <ion-button (click)="loginWithFB()" [disabled]="processingFacebookSignin">
              <div class="featureIcons">
                <img src="assets/imgs/icons/facebook-icon.svg" alt="Facebook logo" />
              </div>
            </ion-button>
          </div>
          <div class="circleButtonWrapper" *ngIf="isIos && isNative">
            <ion-button (click)="appleSignin()" [disabled]="processingAppleSignin">
              <div class="featureIcons">
                <img src="assets/imgs/icons/apple-icon.svg" alt="Apple logo" />
              </div>
            </ion-button>
          </div>
        </div>
        <ion-button (click)="handleCreateAccountClick()" shape="round" expand="full" class="createAccount">
          <div class="featureText">
            {{ 'createAccount' | translate }}
          </div>
        </ion-button>
        <ion-button (click)="openDefaultLogin()" shape="round" expand="full" class="loginEmail">
          <div class="featureText">
            {{ 'loginWithEmail' | translate }}
          </div>
        </ion-button>
        <div class="terms-description">
          {{ 'onRegister' | translate }} 
          <a target="_blank" rel="noopener noreferrer" [href]="'https://' + ('termsURL' | translate)" class="highlight-text">{{ 'termsOfUse' | translate }}</a>
          <span>{{ 'and' | translate }}</span>
          <a target="_blank" rel="noopener noreferrer" [href]="'https://' + ('privacyURL' | translate)" class="highlight-text">{{ 'privacyPolicy' | translate }}</a>
          {{ 'vinculate' | translate }} 
        </div>
      </div>
    </div>
  </div>
  </ng-container>

  <ng-template #webLanding>
    <main class="web-landing">
      <header class="web-landing__header" *ngIf="showWebAuthentication">
        <ion-icon
          name="chevron-back-outline"
          class="web-landing__back"
          role="button"
          tabindex="0"
          [attr.aria-label]="'webLandingBack' | translate"
          (click)="hideJoinOptions()"
          (keydown.enter)="hideJoinOptions()"
          (keydown.space)="hideJoinOptions()">
        </ion-icon>
      </header>
      <section class="web-landing__hero">
        <div class="web-landing__copy">
          <img class="web-landing__logo" src="assets/imgs/veggly-logo.png" alt="Veggly" />
          <div class="affiliate-copy" *ngIf="affiliateLandingHtml" [innerHTML]="affiliateLandingHtml"></div>
          <ng-container *ngIf="!affiliateLandingHtml">
            <p class="eyebrow">{{ 'webLandingEyebrow' | translate }}</p>
            <h1>{{ 'webLandingHeadline' | translate }}</h1>
            <p>{{ 'webLandingSubhead' | translate }}</p>
          </ng-container>
          <div class="web-landing__actions" *ngIf="!showWebAuthentication">
            <ion-button shape="round" size="large" (click)="showJoinOptions()">{{ 'webLandingJoinNow' | translate }}</ion-button>
            <button type="button" class="login-link" (click)="showExistingLogin()">{{ 'webLandingAlreadyHaveAccount' | translate }}</button>
          </div>
          <div class="web-auth" *ngIf="showWebAuthentication">
            <p>{{ 'webLandingChooseHowToJoin' | translate }}</p>
            <ion-button shape="round" expand="block" (click)="googleSignIn()" [disabled]="processingGoogleSignin">{{ 'webLandingContinueGoogle' | translate }}</ion-button>
            <ion-button shape="round" expand="block" (click)="loginWithFB()" [disabled]="processingFacebookSignin">{{ 'webLandingContinueFacebook' | translate }}</ion-button>
            <ion-button fill="outline" shape="round" expand="block" (click)="openSignup()">{{ 'webLandingContinueEmail' | translate }}</ion-button>
          </div>
          <p class="web-landing__legal">
            {{ 'webLandingLegalBefore' | translate }}
            <a target="_blank" rel="noopener noreferrer" [href]="'https://' + ('termsURL' | translate)">{{ 'webLandingLegalTerms' | translate }}</a>
            {{ 'webLandingLegalAnd' | translate }}
            <a target="_blank" rel="noopener noreferrer" [href]="'https://' + ('privacyURL' | translate)">{{ 'webLandingLegalPrivacy' | translate }}</a>{{ 'webLandingLegalAfter' | translate }}
          </p>
        </div>
      </section>
    </main>
  </ng-template>
</ion-content>
